<script>
  import { onMount } from 'svelte';

  import { ComponentType } from '../../../../js/constants';

  import DesktopNav from './DesktopNav/DesktopNav.svelte';
  import MobileNav from './MobileNav/MobileNav.svelte';
  import Waypoint from '../../Waypoint/Waypoint.svelte';

  const STICKY_HTML_CLASS = 'pwn-has-sticky-cta-subnav';

  export let data = {};

  let documentEl;
  let dynamicVariation;
  let isPastWaypoint = false;
  let hiddenUntilScrolled = Boolean(data.hiddenUntilScrolled);
  $: isSticky = isPastWaypoint && !data.disableStickyBehavior;

  function setDynamicVariation() {
    const dynamicVariationQueryParam = new URLSearchParams(window.location.search).get('v');

    dynamicVariation = data.dynamicVariations.find(
      (variation) => variation.dynamicVariationSlug === dynamicVariationQueryParam
    );

    if (dynamicVariation) {
      data = dynamicVariation;
    }
  }

  onMount(() => {
    documentEl = document.documentElement;

    if (data.enableDynamicVariations && Array.isArray(data.dynamicVariations)) {
      setDynamicVariation();
    }
  });

  $: if (documentEl) {
    documentEl.classList.toggle(STICKY_HTML_CLASS, !data.disableStickyBehavior);
  }
</script>

<div class="CtaSubnav" data-component-type={ComponentType.SUBNAVIGATION}>
  <!--
    When the user scrolls past the waypoint, the nav becomes "sticky":
    - The nav element's CSS position switches from relative to fixed
    - The nav element is therefore removed from the document layout
    - A "shim" element is inserted into the layout, replacing the vertical
      space that the nav element used to take up in the layout, to prevent
      the page content from shifting upwards and being covered by the nav
    - The shim height is bound to the height of the nav element height.
  -->
  <Waypoint bind:isPast={isPastWaypoint} bind:hiddenUntilScrolled />
  <DesktopNav {data} {isSticky} {hiddenUntilScrolled} />
  <MobileNav {data} {isSticky} {hiddenUntilScrolled} />
</div>
